import { getMemberLevelPropertiesByCode } from '../../modules/utils';

/**
 * Extended helper for Account Overview Notification V2
 * Returns member properties with tier-specific background colors for the notification banner
 * This extends getMemberLevelPropertiesByCode without modifying the global helper
 */
export const getMemberLevelPropertiesForNotificationV2 = (
  code: string,
  memberStatusList: Array<{ id: string; label: string }>,
  numberOfNights?: string | number
) => {
  // Get base properties from global helper
  const baseProperties = getMemberLevelPropertiesByCode(code, memberStatusList, numberOfNights);

  // Override backgroundColor with tier-specific background colors from memerLevelBackground
  // The global helper already provides memerLevelBackground which should be used as the banner background
  return {
    ...baseProperties,
    backgroundColor: baseProperties.memerLevelBackground || baseProperties.backgroundColor,
    borderLeft: baseProperties.borderLeft,
    bonusPoints: baseProperties.bonusPoints,
    memberLevel: baseProperties.memberLevel,
  };
};
